import { useCallback } from 'react';
import { useDrawer } from '../../../core';
import { PromoCodeForm } from '../components/PromoCodeForm';
import { useUpdatePromoCodeMutation } from '../store/promo-code.api';

export const UpdatePromoCode: React.FC = () => {
  const [updatePromoCode, { isSuccess }] = useUpdatePromoCodeMutation();
  const { resource } = useDrawer();

  const onFinish = useCallback(
    (values: any) => {
      if (!resource) {
        return;
      }

      updatePromoCode({
        id: resource.id,
        ...values,
      });
    },
    [updatePromoCode, resource],
  );

  return <PromoCodeForm onFinish={onFinish} isSubmitted={isSuccess} />;
};
